<ul class="nav level-2" *ngIf="!selectedCharts.size">
  <li class="nav-item template-name">
    <span class="nav-label">
      <span>{{ dashboard?.name }}</span>
    </span>
  </li>
  <div class="state-toggle-container">
    <cc-state-toggle [defaultValue]="view" [theme]="stateToggleTheme" class="sm-bg-grey-3" #stateToggle>
      <cc-state-toggle-item [value]="moduleViews.Grid" routerLink="../grid">
        <div class="sm-flex sm-items-center sm-space-x-1">
          <i class="cc-icon cc-icon-grid" aria-hidden="true"></i>
          <span i18n>Grid</span>
        </div>
      </cc-state-toggle-item>
      <cc-state-toggle-item [value]="moduleViews.Register" routerLink="../register">
        <div class="sm-flex sm-items-center sm-space-x-1">
          <i class="cc-icon cc-icon-register" aria-hidden="true"></i>
          <span i18n>Register</span>
        </div>
      </cc-state-toggle-item>
    </cc-state-toggle>
  </div>

  <li class="nav-item sm-mr-2" *ngIf="companyId">
    <cc-flowsite-banner templateName="power-bi-and-excel-for-analytics-tab" [companyId]="companyId"></cc-flowsite-banner>
  </li>

  <li class="nav-item" data-test="add-chart-btn">
    <a class="nav-link nav-btn-success" (click)="addChart.emit()" ccSegmentCTA="Chart Add">
      <span i18n>Add chart</span>
    </a>
  </li>
</ul>

<ul class="nav level-2" *ngIf="selectedCharts.size">
  <li class="nav-item">
    <a class="nav-link sm-items-center" (click)="deleteSelected.emit()"
      ><i class="cc-icon cc-icon-delete sm-mr-1 sm-text-default-red"></i>Delete</a
    >
  </li>
</ul>
